import { Navigate } from "react-router-dom";
// import { CONFIG } from "../config";

const ProtectedRoute = ({ children }) => {
	const token = localStorage.getItem("token");

	if (!token) {
		// window.location.href = `${CONFIG.FRONTEND_URL}/login`;
		// return null;

		return <Navigate to="/login" replace />;
	}

	return children;
};

export default ProtectedRoute;
